import { useEffect, useState } from "react";
import { Col, message, Row, Tabs } from "antd";
import Currency from "./Currency/Currency";
import Career from "./Career/Career";
import Institution from "./Institutions/Institution";
import Publishers from "./Publishers/Publishers";
import InstitutionLines from "./Lines/InstitutionLines";
import Semester from "./Semester/Semester";
import TypeArticles from "./TypeArticles/TypeArticles";
import TypeBooks from "./TypeBooks/TypeBooks";
import TypeInvestigation from "./TypeInvestigation/TypeInvestigation";
import TypeProducts from "./Typeproducts/TypeProducts";

import CurrencyService from "../../services/CurrencyService.js";
import CareerService from "../../services/CareerService.js";
import InstitutionService from "../../services/InstitutionService.js";
import PublisherService from "../../services/PublisherService.js";
import LineService from "../../services/LineService.js";
import SemesterService from "../../services/SemesterService.js";
import TypeArticleService from "../../services/TypeArticleService.js";
import TypeBookService from "../../services/TypeBookService.js";
import TypeInvestigationService from "../../services/TypeInvestigationService.js";
import TypeProductService from "../../services/typeProductService.js";

import LoaderSpin from "../Layouts/Loader/LoaderSpin";
import { useSelector } from "react-redux";
import { selectCenterInformation } from "../../Auth/centerInformationReducer.js"
const { TabPane } = Tabs;

const getCurrency = () => {
  return new Promise((resolve, reject) => {
    CurrencyService.getCurrencies()
      .then((res) => {
        resolve(res.data.response);
      })
      .catch((e) => {
        message.error("Hubo un error. " + e.message);
        console.log("error.", e.message);
        reject({ status: "error", message: "Hubo un error. " + e.message });
      });
  });
};
const getCareer = () => {
  return new Promise((resolve, reject) => {
    CareerService.getCareers()
      .then((res) => {
        resolve(res.data.response);
      })
      .catch((e) => {
        message.error("Hubo un error. " + e.message);
        console.log("error.", e.message);
        reject({ status: "error", message: "Hubo un error. " + e.message });
      });
  });
};
const getInstitution = () => {
  return new Promise((resolve, reject) => {
    InstitutionService.getInstitutions()
      .then((res) => {
        resolve(res.data.response);
      })
      .catch((e) => {
        message.error("Hubo un error. " + e.message);
        console.log("error.", e.message);
        reject({ status: "error", message: "Hubo un error. " + e.message });
      });
  });
};
const getPublisher = () => {
  return new Promise((resolve, reject) => {
    PublisherService.getPublishers()
      .then((res) => {
        resolve(res.data.response);
      })
      .catch((e) => {
        message.error("Hubo un error. " + e.message);
        console.log("error.", e.message);
        reject({ status: "error", message: "Hubo un error. " + e.message });
      });
  });
};
const getLine = (centerId) => {
  return new Promise((resolve, reject) => {
    LineService.getInstitutionalLinesByCenter(centerId)
      .then((res) => {
        resolve(res.data.response);
      })
      .catch((e) => {
        message.error("Hubo un error. " + e.message);
        console.log("error.", e.message);
        reject({ status: "error", message: "Hubo un error. " + e.message });
      });
  });
};
const getSemester = () => {
  return new Promise((resolve, reject) => {
    SemesterService.getSemesters()
      .then((res) => {
        resolve(res.data.response);
      })
      .catch((e) => {
        message.error("Hubo un error. " + e.message);
        console.log("error.", e.message);
        reject({ status: "error", message: "Hubo un error. " + e.message });
      });
  });
};
const getTypeArticle = () => {
  return new Promise((resolve, reject) => {
    TypeArticleService.getTypeArticle()
      .then((res) => {
        resolve(res.data.response);
      })
      .catch((e) => {
        message.error("Hubo un error. " + e.message);
        console.log("error.", e.message);
        reject({ status: "error", message: "Hubo un error. " + e.message });
      });
  });
};
const getTypeBook = () => {
  return new Promise((resolve, reject) => {
    TypeBookService.getTypeBooks()
      .then((res) => {
        resolve(res.data.response);
      })
      .catch((e) => {
        message.error("Hubo un error. " + e.message);
        console.log("error.", e.message);
        reject({ status: "error", message: "Hubo un error. " + e.message });
      });
  });
};
const getTypeInvestigation = () => {
  return new Promise((resolve, reject) => {
    TypeInvestigationService.getTypeInvestigation()
      .then((res) => {
        resolve(res.data.response);
      })
      .catch((e) => {
        message.error("Hubo un error. " + e.message);
        console.log("error.", e.message);
        reject({ status: "error", message: "Hubo un error. " + e.message });
      });
  });
};
const gettypeProduct = () => {
  return new Promise((resolve, reject) => {
    TypeProductService.getTypeProduct()
      .then((res) => {
        resolve(res.data?.response);
      })
      .catch((e) => {
        message.error("Hubo un error. " + e.message);
        console.log("error.", e.message);
        reject({ status: "error", message: "Hubo un error. " + e.message });
      });
  });
};

export default function BaseInformation() {
  const [currencys, setCurrencys] = useState([]);
  const [careers, setCareers] = useState([]);
  const [institutions, setInstitutions] = useState([]);
  const [publishers, setPublishers] = useState([]);
  const [lines, setLines] = useState([]);
  const [semesters, setSemesters] = useState([]);
  const [typeArticles, setTypeArticles] = useState([]);
  const [typeBooks, setTypeBooks] = useState([]);
  const [typeInvestigations, setTypeInvestigations] = useState([]);
  const [typeProducts, settypeProducts] = useState([]);
  const [isLoading, setIsLoading] = useState({
    status: "loading",
    message: "",
  });
  const centerSession=useSelector(selectCenterInformation).centerInformation
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    let isLoadingStatus = { status: "success", message: "" };
    let promises = [
      getCurrency(),
      getCareer(),
      getInstitution(),
      getPublisher(),
      getTypeArticle(),
      getTypeBook(),
      gettypeProduct(),
      getTypeInvestigation(),
      getSemester(),
      getLine(centerSession.id),
    ];
    Promise.allSettled(promises).then((results) => {
      results.forEach((result, index) => {
        if (result.status === "fulfilled") {
          switch (index) {
            case 0:
              setCurrencys(result.value || []);
              break;
            case 1:
              setCareers(result.value || []);
              break;
            case 2:
              setInstitutions(result.value || []);
              break;
            case 3:
              setPublishers(result.value || []);
              break;
            case 4:
              setTypeArticles(result.value || []);
              break;
            case 5:
              setTypeBooks(result.value || []);
              break;
            case 6:
              settypeProducts(result.value || []);
              break;
            case 7:
              setTypeInvestigations(result.value || []);
              break;
            case 8:
              setSemesters(result.value || []);
              break;
            case 9:
              setLines(result.value || []);
              break;
            default:
              break;
          }
        }
      });
    });
    setIsLoading(isLoadingStatus);
  };

  if (isLoading.status === "loading" || isLoading.status === "error") {
    return <LoaderSpin isLoading={isLoading} />;
  }

  return (
    <>
      <Row justify="center">
        <Col span={23}>
          <Tabs defaultActiveKey="1" destroyInactiveTabPane={true}>
            <TabPane tab={<span>Monedas</span>} key="1">
              <Currency
                list={currencys}
                getData={getCurrency}
                setCurrencys={setCurrencys}
              />
            </TabPane>
            <TabPane tab={<span>Carreras</span>} key="2">
              <Career
                list={careers}
                setCareers={setCareers}
                getData={getCareer}
              />
            </TabPane>
            <TabPane tab={<span>Instituciones</span>} key="3">
              <Institution
                list={institutions}
                getData={getInstitution}
                setInstitutions={setInstitutions}
              />
            </TabPane>
            <TabPane tab={<span>Editoriales</span>} key="4">
              <Publishers
                list={publishers}
                getData={getPublisher}
                setPublishers={setPublishers}
              />
            </TabPane>
            <TabPane tab={<span>Líneas Institucionales</span>} key="5">
              {" "}
              <InstitutionLines
                CenterId={centerSession.id}
                list={lines}
                getData={getLine}
                setLines={setLines}
              />
            </TabPane>
            <TabPane tab={<span>Semestres</span>} key="6">
              {" "}
              <Semester
                list={semesters}
                getData={getSemester}
                setSemesters={setSemesters}
              />
            </TabPane>
            <TabPane tab={<span>Tipo de Artículos</span>} key="7">
              <TypeArticles
                list={typeArticles}
                getData={getTypeArticle}
                setTypeArticles={setTypeArticles}
              />
            </TabPane>
            <TabPane tab={<span>Tipo de Libros</span>} key="8">
              <TypeBooks
                list={typeBooks}
                getData={getTypeBook}
                setTypeBooks={setTypeBooks}
              />
            </TabPane>
            <TabPane tab={<span>Tipo de Investigaciones</span>} key="9">
              <TypeInvestigation
                list={typeInvestigations}
                getData={getTypeInvestigation}
                setTypeInvestigations={setTypeInvestigations}
              />
            </TabPane>
            <TabPane tab={<span>Tipo de Productos</span>} key="10">
              <TypeProducts
                list={typeProducts}
                getData={gettypeProduct}
                settypeProducts={settypeProducts}
              />
            </TabPane>
          </Tabs>
        </Col>
      </Row>
    </>
  );
}
